import BankAccountVerificationModal from 'app/views/modals/bank_account_verification_modal';
import OneTimeChargeModal from 'app/views/modals/one_time_charge_modal';
import RechargeSettingsView from 'app/views/recharge_settings_view';
import PaymentMethodRemoveModal from 'app/views/modals/payment_method_remove_modal';

import Base from 'app/views/base';
import tmpl from 'templates/bank_account_details';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .verify_account': 'showVerificationModal',
    'click .one-time-charge': 'showOneTimeChargeModal',
    'click .remove_account': 'showRemoveModal',
  },

  initialize({ priority, paymentMethods, user }) {
    this.priority = priority;
    this.paymentMethods = paymentMethods;
    this.user = user;

    this.listenTo(this.model, 'change', this.render);
    this.verificationModal = new BankAccountVerificationModal({ model: this.model });
    this.oneTimeChargeModal = new OneTimeChargeModal({
      user: this.user,
      model: this.model,
      collection: this.collection,
    });

    this.addSubview('rechargeSettings', '.recharge_settings', new RechargeSettingsView({
      model: this.user, priority: this.priority,
    }));
  },

  context() {
    return {
      bank_name: this.model.get('bank_name'),
      last4: this.model.get('last4'),
      country: this.model.get('country'),
      verified: !!this.model.get('verified'),
    };
  },

  showVerificationModal(event) {
    event.preventDefault();
    this.verificationModal.show();
  },

  showOneTimeChargeModal(event) {
    event.preventDefault();
    this.oneTimeChargeModal.show();
  },

  showRemoveModal(event) {
    event.preventDefault();
    if (this.removeModal) {
      this.removeModal.close();
    }

    this.removeModal = new PaymentMethodRemoveModal({
      model: this.model,
      collection: this.paymentMethods,
      priority: this.priority,
    });

    this.removeModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/bank_account_details_view.js